export default {
  namespaced: true,
  state: () => ({
    status: []
  }),
  getters: {
    isOnline: state => (id) => {
      for (const val of state.status) {
        if (val.userId === id && val.status === 'online') {
          return true
        }
      }
      return false
    }
  },
  mutations: {
    push (state, { userId, status }) {
      for (const i in state.status) {
        if (state.status[i].userId === userId) {
          state.status.splice(i, 1)
        }
      }
      state.status.push({ userId: userId, status: status })
    }
  }
}
